module.exports = __webpack_public_path__ + "static/education-icon-button-43858e06d08e702bd8ba519d48af49f1.png";